
























































import {Component, Vue} from "vue-property-decorator";
import PTOViewEmployee from "@/components/payroll/policies/pto/PTOViewEmployee.vue";
import {IEmployment} from "@/dto/payroll/IEmployment";
import Application from "@/state/Application";
import EmploymentService from "@/services/EmploymentService";
import {EmploymentFilter} from "@/dto/payroll/Filters";
import {processError} from "@/utils/ComponentUtils";
import {EmploymentStatus} from "@/components/payroll/business/employments/contractors/Contractor";
import {EmploymentType} from "@/constants/EmploymentType";
import PolicyService from "@/services/payroll/PolicyService";
import {CounterpartyType} from "@/constants/CounterpartyType";

interface TypeGroup {
	typeKey: string;
	typeLabel: string;
	employments: IEmployment[];
}

interface CompanyGroup {
	companyId: number;
	companyName: string;
	typeGroups: TypeGroup[];
}

const EMPLOYMENT_TYPE_ORDER: (EmploymentType | null)[] = [
	EmploymentType.STAFF,
	EmploymentType.FOREIGN,
	null
];

@Component({
	components: { PTOViewEmployee }
})
export default class IndividualPTOPolicy extends Vue {
	private employments: IEmployment[] = [];
	/** Только трудоустройства, у которых назначена политика PTO (для отображения сотруднику) */
	private employmentsWithPto: IEmployment[] = [];
	private loading = true;

	private filter = new EmploymentFilter({
		detailsId: this.$wss.getCurrent.id,
		types: [EmploymentType.STAFF, EmploymentType.FOREIGN],
		contractorType: CounterpartyType.PERSON,
		status: [EmploymentStatus.NEW, EmploymentStatus.ACTIVE, EmploymentStatus.PENDING_FOR_DOCUMENTS]
	});

	private get groupedByCompany(): CompanyGroup[] {
		const byCompany = new Map<number, { name: string; employments: IEmployment[] }>();

		for (const e of this.employmentsWithPto) {
			const id = e.employer && e.employer.id != null ? e.employer.id : 0;
			const name = (e.employer && e.employer.name) ? e.employer.name : "";
			if (!byCompany.has(id)) {
				byCompany.set(id, { name, employments: [] });
			}
			byCompany.get(id)!.employments.push(e);
		}

		const result: CompanyGroup[] = [];

		byCompany.forEach((value, companyId) => {
			const byType = new Map<string, IEmployment[]>();
			for (const e of value.employments) {
				const key = e.employmentType != null ? e.employmentType : "__null__";
				if (!byType.has(key)) byType.set(key, []);
				byType.get(key)!.push(e);
			}

			const typeGroups: TypeGroup[] = [];
			for (const type of EMPLOYMENT_TYPE_ORDER) {
				const key = type != null ? type : "__null__";
				const list = byType.get(key);
				if (!list || list.length === 0) continue;
				const typeLabel = this.getEmploymentTypeLabel(type);
				typeGroups.push({ typeKey: key, typeLabel, employments: list });
			}

			result.push({
				companyId,
				companyName: value.name,
				typeGroups
			});
		});

		return result;
	}

	private getEmploymentTypeLabel(type: EmploymentType | null): string {
		if (type === EmploymentType.STAFF) return this.$t("payroll.pto.employmentTypeStaff") as string;
		if (type === EmploymentType.CONTRACTOR) return this.$t("payroll.pto.employmentTypeContractor") as string;
		if (type === EmploymentType.FOREIGN) return this.$t("payroll.pto.employmentTypeForeign") as string;
		return this.$t("payroll.pto.employmentTypeOther") as string;
	}

	private loadEmployments() {
		Application.startLoading();
		this.loading = true;
		EmploymentService.getPageByFilter<IEmployment>(this.filter).then(
			res => {
				this.employments = res.data.data || [];
				this.filterEmploymentsWithPto();
			},
			err => {
				processError(err, this);
				this.loading = false;
				Application.stopLoading();
			}
		);
	}

	/** Оставляет только трудоустройства, у которых есть назначенная политика PTO. */
	private filterEmploymentsWithPto() {
		const withId = this.employments.filter(e => e.id != null);
		if (withId.length === 0) {
			this.employmentsWithPto = [];
			this.loading = false;
			Application.stopLoading();
			return;
		}
		const promises = withId.map(e =>
			PolicyService.getPTOPolicyByEmploymentId(e.id!)
				.then(() => e as IEmployment | null)
				.catch(() => null)
		);
		Promise.all(promises).then(results => {
			this.employmentsWithPto = results.filter((e): e is IEmployment => e != null);
			this.loading = false;
			Application.stopLoading();
		});
	}

	public created(): void {
		this.loadEmployments();
	}
}
